import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse, HttpParams, HttpResponse} from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LoggingService } from './log.service';
import { throwError } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { UtilsService } from './utils.service';



@Injectable()
export class RestfulService {

  public baseurl = environment.restBaseUrl;
  public testUrl = environment.testBaseUrl;

  constructor(
    private http: HttpClient,
    private logger: LoggingService,
    private router: Router,
    private settings: SettingsService,
    private utilsService: UtilsService
  ) { }

  // TODO: Rimuovere i parametri test dai metodi quando tutte le chiamate sono configurate

  // POST http request
  post(endPoint: string, reqBody) {
    const url = this.baseurl + endPoint;
    return this.http
      .post<any[]>(url, reqBody, this.getRequestOptionArgs())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  postMultipart(endPoint: string, reqBody) {
    const url = this.baseurl + endPoint;
    const options =  {
      headers: new HttpHeaders({
        'X-Auth-Token':  localStorage.getItem("token") || ''
      })
    };
    return this.http
      .post<any[]>(url, reqBody, options)
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  // POST http request
  post_downloadFile(endPoint: string, reqBody) {
    const url = this.baseurl + endPoint;
    return this.http
      .post<any[]>(url, reqBody, this.getRequestOptionArgs_downlodFile())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        return throwError(errorResponse.message);
      }
      ));
  }

  // GET http request
  get(endPoint: string, testAPI?: boolean) {
    const url = testAPI ? this.testUrl + endPoint : this.baseurl + endPoint;
    return this.http
      .get<any[]>(url, this.getRequestOptionArgs())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  getWithParams(endPoint: string, params: HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      }, testAPI?: boolean) {
    const url = testAPI ? this.testUrl + endPoint : this.baseurl + endPoint;
    const requestOptions = this.getRequestOptionArgs();
    requestOptions.params = params
    return this.http
      .get<any[]>(url, requestOptions)
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  // GET http request
  get_downloadFile(endPoint) {
    const url = this.baseurl + endPoint;
    return this.http
      .get<any[]>(url, this.getRequestOptionArgs_downlodFile())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        return throwError(errorResponse.message);
      }
      ));
  }

  download(endPoint, openInNewTab = true) {
    const url = this.baseurl + endPoint;
    return this.http
        .get(url, this.downloadOptions())
        .pipe(
            map((response: any) => {
              // Extract filename from Content-Disposition header
              const contentDisposition = response.headers.get('Content-Disposition');
              let filename = 'download.pdf'; // default

              if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, '');
                }
              }

              const blob = response.body
              if(openInNewTab) {
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob as unknown as Blob);
                link.href = url;
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(url);
              }

              return {
                blob: blob,
                filename: filename
              };
            }),
            catchError((errorResponse: HttpErrorResponse) => {
              return throwError(() => errorResponse.message);
            })
        );
  }

  downloadOptions(): any {
    const httpOptions = {
      responseType: "blob" as "json", // TypeScript workaround
      observe: "response" as "body",   // THIS IS KEY - gives you access to headers
      headers: new HttpHeaders({
        // Remove 'Content-Type': 'application/json' - you're downloading, not sending JSON
        'X-Auth-Token': localStorage.getItem("token") || ''
      })
    };
    return httpOptions;
  }

  // PUT http request
  put(endPoint, reqBody?) {
    const url = this.baseurl + endPoint;
    return this.http
      .put<any[]>(url, reqBody, this.getRequestOptionArgs())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  // DELETE http request
  delete(endPoint) {
    const url = this.baseurl + endPoint;
    return this.http
      .delete<any[]>(url, this.getRequestOptionArgs())
      .pipe(map(
        (response) => response
      ), catchError((errorResponse: HttpErrorResponse) => {
        const res: any = errorResponse.error;
        if (res.outcome) {
          if (res.outcome.code === "0005" || res.outcome.code === "0007") {
            this.utilsService.sessionExpired();
          }
        }
        return throwError(errorResponse.message);
      }
      ));
  }

  getRequestOptionArgs(params?: HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  }): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token':  localStorage.getItem("token") || ''
      }),
      params: params ? params: []
    };
    return httpOptions;
  }

  getRequestOptionArgs_downlodFile(): any {
    const httpOptions = {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Auth-Token': localStorage.getItem("token") || ''
      })
    };
    return httpOptions;
  }
}

